export default "/_next/static/6bcbd9fc62c19743369a8b027555843b.gif";